document.addEventListener("DOMContentLoaded", () => {
  async function removeBatteryFeeProducts() {
    try {
      const cartResponse = await fetch("/cart.js");
      if (!cartResponse.ok) throw new Error("Failed to fetch cart.js");

      const cart = await cartResponse.json();

      // Find all items with product_type containing "fee"
      const batteryFeeItems = cart.items.filter(
        (item) =>
          item.product_type && item.product_type.toLowerCase().includes("fee")
      );

      if (batteryFeeItems.length === 0) {
        console.log("No battery fee items found in cart.");
        return;
      }

      // Prepare a payload to set quantities to 0 for all matching items
      const updates = batteryFeeItems.reduce((acc, item) => {
        acc[item.key] = 0;
        return acc;
      }, {});

      // Send a single update request
      const updateResponse = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      });

      if (!updateResponse.ok) throw new Error("Failed to update cart");

      const result = await updateResponse.json();
      if (result.errors) {
        console.error("Error updating cart:", result.errors);
      } else {
        console.log("Cart updated successfully:", result);
        location.reload(); // Optionally reload the page to reflect changes
      }
    } catch (error) {
      console.error("Error handling cart:", error);
    }
  }

  // removeBatteryFeeProducts();
});
